<template>
  <div>
  <EditCategory
    @editDetail="editCategory"
    @cancelEdit="cancelEdit"
    :categoryId="categoryId"
  />
  <ProductList
    :categoryId="categoryId"
  />
  </div>
</template>

<script>
  import EditCategory from '../../../components/WebStore/categories/edit';
  import ProductList from '../../../components/WebStore/categories/productList';
  import { mapActions } from 'vuex';

  export default {
    name: 'Edit-Category',
    components:{
      EditCategory,
      ProductList,
    },
    data: () => ({
      categoryId: '',
    }),
    methods:{
      ...mapActions('category', [
        'updateCategoryDetails',
      ]),
      ...mapActions('ecommerce',['algoliaSync']),
      editCategory(data){
        let self=this;
        let value = {
          id: this.categoryId,
          info: data,
        };
        this.updateCategoryDetails(value).then(() => {
          self.algoliaSync();
          self.$vs.notify({
            title: 'Category Edit',
            text: 'Category edited successfully',
            color: 'success',
          });
          self.$vs.loading.close();
          this.$router.push({ name: 'AdminCategoryManagement'});
        });
      },
      cancelEdit() {
        this.$router.push({ name: 'AdminCategoryManagement'});
      },
    },
    async created() {
      this.categoryId = this.$route.params.categoryId;
    },
  };
</script>
